export default __webpack_public_path__ + "static/media/69.a7ff98b3.jpg";